"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Label.types.js.map